<template>
  <!-- 底部信息 -->
  <footer>
    <div class="footer-menus">
      <div class="contact-us">
        <p class="menu-title">联系我们</p>
        <p>地址：哈尔滨市南岗区红旗大街与赣水路交口</p>
        <p>邮件：business@jiecangtech.com</p>
        <div class="qr-wrapper">
          <img src="../assets/images/background/QR-code.jpg" alt="二维码">
        </div>
      </div>

      <div class="service-menu">
        <p class="menu-title">服务概览</p>
        <ul class="menu-items">
          <li><router-link to="/service">网站建设</router-link></li>
          <li><router-link to="/service">网页设计</router-link></li>
          <li><router-link to="/service">移动应用</router-link></li>
          <li><router-link to="/service">系统运维</router-link></li>
        </ul>
      </div>

      <div class="service-menu">
        <p class="menu-title">产品</p>
        <ul class="menu-items">
          <li>
            <router-link to="/product/database-audit">数据库审计平台</router-link>
          </li>
          <li>
            <router-link to="/product/ops-security">运维安全管控平台</router-link>
          </li>
          <li>
            <router-link to="/product/ai-ops-platform">智能运维管理平台</router-link>
          </li>
          <li><router-link to="/product">⋯</router-link></li>
        </ul>
      </div>

      <div class="footer-bottom">
        <!-- 优化后的 ICP 备案区域 -->
        <div class="icp-info">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            黑ICP备2023000756号-1
          </a>
          <span class="separator">|</span>
          <div class="police-wrapper">
            <img src="../assets/images/logo/police_badge.png" alt="公安备案图标" class="police-icon">
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener noreferrer">
              黑公网安备23010302001506号
            </a>
          </div>
        </div>
        <p class="rights">&copy; 哈尔滨杰仓科技有限责任公司</p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
/* 底部信息 */
footer {
  margin-top: 124px;
  background-color: #181818;
  display: flex;
  justify-content: center;
  padding: 72px 80px 24px;
}

.footer-menus {
  width: 100%;
  max-width: 1280px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 40px 20px;
}

.menu-title {
  font-size: 16px;
  color: white;
  font-weight: 500;
  margin-bottom: 20px;
}

.contact-us {
  color: var(--text-color-lightest, #999);
}

.contact-us p:not(:first-child) {
  margin-bottom: 16px;
  line-height: 1.6;
}

/* 二维码样式 */
.qr-wrapper {
  margin-bottom: 16px;
}
.qr-wrapper img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
}

.menu-items {
  padding: 0;
  margin: 0;
  text-align: left;
}

.menu-items li {
  list-style: none;
  margin-bottom: 8px;
}

.menu-items li:last-child {
  margin-bottom: 0;
}

.menu-items a {
  text-decoration: none;
  font-weight: 300;
  color: var(--text-color-lightest, #999);
  transition: color 0.3s ease;
}

.menu-items a:hover {
  color: white;
}

/* 服务概览 & 产品 居中 */
.service-menu:nth-child(2),
.service-menu:nth-child(3) {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.service-menu:nth-child(2) .menu-title,
.service-menu:nth-child(3) .menu-title {
  text-align: center;
}
.service-menu:nth-child(3) .menu-items {
  width: fit-content;
  text-align: left;
}

.footer-bottom {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.icp-info,
.rights {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin: 0;
}

/* ========== 优化：备案信息样式 ========== */
.icp-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  line-height: 1;
}
.icp-info .separator {
  color: rgba(255, 255, 255, 0.3);
  user-select: none;
}
.police-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}
.police-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  vertical-align: middle;
}
.icp-info a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
  white-space: nowrap;
}
.icp-info a:hover {
  color: rgba(255, 255, 255, 0.9);
}

/* 平板适配 */
@media (max-width: 992px) {
  footer {
    padding-left: 40px;
    padding-right: 40px;
  }
  .footer-menus {
    gap: 30px 20px;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  footer {
    margin-top: 80px;
    padding: 48px 24px 24px;
  }
  .footer-menus {
    grid-template-columns: 1fr 1fr;
    gap: 32px 20px;
  }
  .contact-us {
    grid-column: 1 / -1;
    text-align: center;
  }
  .qr-wrapper {
    justify-content: center;
    display: flex;
  }
}

/* 小屏幕移动端 */
@media (max-width: 576px) {
  .footer-menus {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 24px;
  }
  .contact-us { order: 1; }
  .service-menu { order: 2; }
  .footer-bottom { order: 3; padding-top: 16px; }
  .service-menu:nth-child(3) .menu-items {
    margin: 0 auto;
    text-align: center;
  }
}
</style>